import { useQuery } from 'react-query';
import { queryKeys } from './queryKeys';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { Language, LanguageCode } from '../../CommonSelectors/CommonArea.types';

export interface LanguagePreferenceDTO {
  label: LanguageCode;
  value: Language;
}

const fetchLocalizeOptions = (clientId: string): Promise<LanguagePreferenceDTO[]> =>
  authFetch(urlWithParams('/Consumer/Localize/Options', { clientId }));

export const useLocalizeOptionsQuery = (clientId: string) =>
  useQuery(queryKeys.localize(clientId), () => fetchLocalizeOptions(clientId));
